import { render, staticRenderFns } from "./_logs.component.vue?vue&type=template&id=620e0505&scoped=true&"
import script from "./_logs.component.vue?vue&type=script&lang=js&"
export * from "./_logs.component.vue?vue&type=script&lang=js&"
import style0 from "./_logs.component.vue?vue&type=style&index=0&id=620e0505&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620e0505",
  null
  
)

export default component.exports